import styled, {css} from 'styled-components'

const getColors = (campaign) => campaign && campaign.template && campaign.template.appearence && campaign.template.appearence.colors

const ClassBuilder = styled.div`
  ${props => {
    const colors = getColors(props.campaign)
    const brandDefault = colors && colors["brand-default"]
    const brandHover = colors && colors["brand-hover"]
    const brandPressed = colors && colors["brand-pressed"]
    const textTertiary = colors && colors["text-tertiary"]

    return props.campaign && css`
      .primary-text {
        color: ${brandDefault}
      }
      .secondary-text {
        color: ${brandHover}
      }

      .navbar-text {
        color: ${textTertiary}
      }

      .text-color {
        color: ${brandPressed}
      }

      .primary-bg {
        background: ${brandDefault}
        &:disabled{
          background: #ccc;
          cursor: not-allowed;
        }
      }

      .secondary-bg {
        background: ${brandHover}
      }

      .mish-bg {
        background: ${brandPressed}
      }

      .border-primary {
        border-color: ${brandDefault}
      }

      .border-secondary {
        border-color: ${brandHover}
      }

      .custom-select__option:hover{
        color: ${textTertiary};
        background-color: ${brandHover};
      }
      .custom-select__option--is-focused{
        background-color: ${brandHover};
        color: ${textTertiary};
      }

      .active-link {
        color: ${textTertiary};
        background:${brandDefault};

        &:hover {
          background:${brandHover};
        }

        &.active {
          background:linear-gradient(to top, ${brandHover} 0%, ${brandHover} 10%, ${brandDefault} 10%, ${brandDefault} 100%);
        }
        &.fromDropdown.active {
          background:${brandHover};
        }
      }

      .hover-secondary {
        &:hover {
          background:${brandHover};
        }
      }

    `
  }}
`

export default ClassBuilder